import { createEvent } from 'effector';

export const setMapLoadedEv = createEvent();

export const resetMapLoadedEv = createEvent();

export const changeInteractivityEv = createEvent();

export const changeDrawModeEv = createEvent();
